import {
  Col,
  Form,
  Input,
  InputNumber,
  Row,
  Select,
  Switch
} from 'antd'
import { useWatch } from 'antd/es/form/Form'
import { useEffect, useMemo, useState } from 'react'
import {
  OPTIONS_OBJECT_POST
} from '../../configData'
import { getAllSelections } from '../../services/selection-list-service'
import {
  buildSubProductTypeFromCategory,
  getSubProductType
} from '../../utils/helpers'
import ModalConfirm from '../common/ModalConfirm/ModalConfirm'
import { OPTIONS_WEB_FEE } from './configs'
const { Option } = Select

const customizeRequiredMark = (label, { required }) => (
  <>
    {label}
    {required && <span style={{ color: 'red' }}> *</span>}
  </>
)
const FormPost = ({
  form,
  mode,
  detailForm,
  demandOps,
  typeOfRealEstateOps,
  listAllSelections,
  postDateOptions
}) => {

  const getDefaultPackageProperties = () => ({
    name: '',
    demand: '',
    status: 'ACTIVE',
    timeEx: '',
    priority: '',
    fontTitle: '',
    promotion: '',
    titleColor: '#000000',
    numberOfPic: '',
    numberOfEdit: null,
    propertyType: '',
    originalPrice: '',
    realEstateType: [],
    targetAudience: ''
  })

  const getDefaultClickProperties = () => ({
    demand: '',
    status: 'ACTIVE',
    promotion: '',
    propertyType: '',
    originalPrice: '',
    identification: '',
    realEstateType: []
  })

  const [packages, setPackages] = useState([
    {
      key: 1,
      // name: '',
      // fee_type: '',
      originalPrice: '',
      demand: '',
      promotion: '',
      propertyType: '',
      realEstateType: [],
      timeEx: null,
      status: true
    }
  ])

  useEffect(() => {
    // Handle both camelCase (from API) and snake_case formats
    const packageFeeInfo =
      detailForm.package_fee_info || detailForm.packageFeeInfo || []

    if (packageFeeInfo && packageFeeInfo.length > 0) {
      const transformedPackages = packageFeeInfo.map((item, index) => {
        // Transform from camelCase to snake_case if needed
        const feeType = item.fee_type || item.feeType || 'PACKAGE'
        const packageProps = item.package_properties || item.packageProperties
        const clickProps = item.click_properties || item.clickProperties

        return {
          key: item.id || Date.now() + index,
          id: item.id || null,
          fee_type: feeType,
          package_properties: packageProps || getDefaultPackageProperties(),
          click_properties: clickProps || getDefaultClickProperties(),
          status: item.status || 'ACTIVE'
        }
      })
      setPackages(transformedPackages)
    } else if (detailForm.fee_type || detailForm.feeType) {
      // If there's a fee_type at root level, create a single package
      const feeType = detailForm.fee_type || detailForm.feeType || 'PACKAGE'
      const packageProps =
        detailForm.package_properties || detailForm.packageProperties
      const clickProps =
        detailForm.click_properties || detailForm.clickProperties

      setPackages([
        {
          key: detailForm.id || 1,
          id: detailForm.id || null,
          fee_type: feeType,
          package_properties: packageProps || getDefaultPackageProperties(),
          click_properties: clickProps || getDefaultClickProperties(),
          status: detailForm.status || 'ACTIVE'
        }
      ])
    }
  }, [detailForm, typeOfRealEstateOps, listAllSelections])

  const addPackage = () => {
    const feeType = form.getFieldValue('fee_type') || 'PACKAGE'
    const newPackage = {
      key: Date.now(),
      demand: '',
      propertyType: '',
      realEstateType: [],
      timeEx: null,
      originalPrice: '',
      promotion: '',
      status: true
    }
    setPackages((prev) => [...prev, newPackage])
  }

  const deletePackage = (key) => {
    setPackages((prev) =>
      prev.map((item) =>
        item.key === key
          ? {
              ...item,
              status: 'DEACTIVE',
              package_properties: {
                ...item.package_properties,
                status: 'DEACTIVE'
              },
              click_properties: {
                ...item.click_properties,
                status: 'DEACTIVE'
              }
            }
          : item
      )
    )
  }
  const [typeRealEstate, setTypeRealEstate] = useState([])

  const SUB_PRODUCT_TYPE_DYNAMIC = useMemo(
    () =>
      buildSubProductTypeFromCategory(listAllSelections, [
        'APARTMENT_BDS',
        'BUILDING_BDS',
        'GROUND_BDS',
        'REAL_ESTATE_BDS'
      ]),
    [listAllSelections]
  )
  const onChangePostType = (e) => {
    const type = getSubProductType(e, SUB_PRODUCT_TYPE_DYNAMIC)

    setTypeRealEstate(type)
  }

  const updatePackage = (key, field, value, propertyType = null) => {
    setPackages((prev) =>
      prev.map((item) => {
        if (item.key !== key) return item

        const feeType =
          item.fee_type || form.getFieldValue('fee_type') || 'PACKAGE'
        const isPackage = feeType === 'PACKAGE'
        const propertiesKey = isPackage
          ? 'package_properties'
          : 'click_properties'

        // Handle nested properties
        if (propertyType === 'package' || (isPackage && !propertyType)) {
          return {
            ...item,
            package_properties: {
              ...item.package_properties,
              [field]: value
            }
          }
        } else if (propertyType === 'click' || (!isPackage && !propertyType)) {
          return {
            ...item,
            click_properties: {
              ...item.click_properties,
              [field]: value
            }
          }
        }

        // Handle top-level fields
        return { ...item, [field]: value }
      })
    )
  }
  useEffect(() => {
    if (detailForm) {
      setTypeRealEstate(
        getSubProductType(
          String(
            detailForm?.packageProperties?.propertyType ||
              detailForm?.clickProperties?.propertyType
          ),
          SUB_PRODUCT_TYPE_DYNAMIC
        )
      )
    }
    // form.setFieldsValue({ package_fee: packages })
  }, [
    detailForm?.packageProperties?.propertyType,
    detailForm?.clickProperties?.propertyType,
    SUB_PRODUCT_TYPE_DYNAMIC
  ])

  const typeW = useWatch('fee_type', form)
  const getFeeProperties = (detailForm) => {
    if (!detailForm) return null

    if (detailForm.feeType === 'CLICK') {
      return detailForm.clickProperties
    }

    if (detailForm.feeType === 'PACKAGE') {
      return detailForm.packageProperties
    }

    return null
  }
  useEffect(() => {
    if (!detailForm) return

    const feeProps = getFeeProperties(detailForm)
    if (!feeProps?.propertyType) return

    const propertyType = feeProps.propertyType
    const realEstateType = feeProps.realEstateType || []

    // 1️⃣ build option
    const options = getSubProductType(propertyType, SUB_PRODUCT_TYPE_DYNAMIC)
    setTypeRealEstate(options)

    // 2️⃣ set form value (bắt buộc)
    form.setFieldsValue({
      propertyType,
      realEstateType
    })
  }, [detailForm, SUB_PRODUCT_TYPE_DYNAMIC])

  return (
    <Form
      form={form}
      labelWrap
      labelAlign="left"
      labelCol={{ span: 6 }}
      layout="horizontal"
      style={{
        marginTop: 10,
        overflow: 'auto',
        overflowX: 'hidden',
        padding: '0px 10px'
      }}
      requiredMark={customizeRequiredMark}
      onValuesChange={(value, allValues) =>
        console.log('Form Data', value, allValues)
      }
      disabled={mode == 'VIEW' ? true : false}
      initialValues={{
        identification: 'INDIVIDUAL',
        status: true
      }}
    >
      <Form.Item name="package_fee" style={{ display: 'none' }}>
        <Input />
      </Form.Item>
      <Form.Item label="" name="id" style={{ display: 'none' }}>
        <Input />
      </Form.Item>
      <Row>
        <Col span={24}>
          <Form.Item
            label="Loại thu phí"
            name="fee_type"
            labelCol={{ span: 3 }}
            rules={[{ required: true, message: 'Vui lòng chọn loại thu phí' }]}
          >
            <Select
              style={{ width: '100%' }}
              placeholder="Chọn loại thu phí"
              // defaultValue="Tất cả"
              disabled={mode == 'UPDATE' ? true : false}
            >
              {OPTIONS_WEB_FEE.map((item, idx) => (
                <Option key={idx} value={item.value}>
                  {item.name}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
      </Row>
      {typeW == 'PACKAGE' && (
        <>
          <Row>
            <Col span={24}>
              <Form.Item
                label="Tên gói"
                name="name"
                labelCol={{ span: 3 }}
                rules={[{ required: true, message: 'Vui lòng nhập tên gói' }]}
              >
                <Input placeholder="Nhập tên gói" />
              </Form.Item>
            </Col>
          </Row>
          {typeW == 'PACKAGE' && (
            <>
              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item
                    label="Độ ưu tiên"
                    name="priority"
                    rules={[
                      { required: true, message: 'Vui lòng nhập độ ưu tiên' }
                    ]}
                  >
                    <Input placeholder="Nhập độ ưu tiên" />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    label="Số lần sửa"
                    name="numberOfEdit"
                    rules={[{ required: true, message: 'Vui lòng số lần sửa' }]}
                  >
                    <InputNumber
                      style={{ width: '100%' }}
                      placeholder="Nhập số lần sửa"
                      // min={1}
                      // max={7}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item
                    label="Số ảnh"
                    name="numberOfPic"
                    rules={[
                      { required: true, message: 'Vui lòng nhập số ảnh' },
                      {
                        type: 'number',
                        min: 5,
                        max: 9,
                        message: 'Số ảnh phải từ 5 đến 9'
                      }
                    ]}
                  >
                    <InputNumber
                      style={{ width: '100%' }}
                      placeholder="Nhập số ảnh"
                      min={5}
                      max={9}
                    />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item label="Đối tượng" name="identification">
                    <Select
                      style={{ width: '100%' }}
                      disabled
                      value={'INDIVIDUAL'}
                      placeholder="Chọn đối tượng"
                    >
                      {OPTIONS_OBJECT_POST.map((item, idx) => (
                        <Option key={idx} value={item.value}>
                          {item.name}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
            </>
          )}
        </>
      )}

      <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            label="Nhu cầu"
            name="demand"
            rules={[{ required: true, message: 'Vui lòng chọn nhu cầu' }]}
          >
            <Select style={{ width: '100%' }} placeholder="Chọn nhu cầu">
              <Option value="sell">Bán</Option>
              <Option value="rent">Thuê</Option>
              <Option value="buying">Tìm mua</Option>
              <Option value="renting">Tìm thuê</Option>
            </Select>
          </Form.Item>
        </Col>
        {typeW == 'PACKAGE' && (
          <Col span={12}>
            <Form.Item
              label="Thời gian"
              name="timeEx"
              rules={[{ required: true, message: 'Vui lòng chọn thời gian' }]}
            >
              <Select style={{ width: '100%' }} placeholder="Chọn thời gian">
                {postDateOptions?.map((option) => (
                  <Option key={option.value} value={option.value}>
                    {option.title}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        )}
      </Row>

      <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            label="Loại BĐS"
            name="propertyType"
            rules={[{ required: true, message: 'Vui lòng chọn loại BĐS' }]}
          >
            <Select
              style={{ width: '100%' }}
              placeholder="Chọn loại BĐS"
              onChange={(value) => {
                //   updatePackage(record.key, 'propertyType', value)
                //   updatePackage(record.key, 'realEstateType', [])
                onChangePostType(String(value))
                form.setFieldsValue({ realEstateType: [] })
              }}
            >
              {typeOfRealEstateOps.map((item) => (
                <Select.Option key={item.value} value={item.value}>
                  {item.label}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            label="Loại hình BĐS"
            name="realEstateType"
            rules={[{ required: true, message: 'Vui lòng chọn loại hình BĐS' }]}
          >
            <Select
              style={{ width: '100%' }}
              mode="multiple"
              onChange={(value) => {
                form.setFieldsValue({ realEstateType: value })
              }}
              placeholder="Chọn loại hình BĐS"
            >
              {typeRealEstate.map((item) => (
                <Select.Option key={item.value} value={item.value}>
                  {item.label}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            label="Giá"
            name="originalPrice"
            rules={[{ required: true, message: 'Vui lòng nhập giá' }]}
          >
            <InputNumber
              style={{ width: '100%' }}
              placeholder="Nhập giá"
              min={0}
              formatter={(value) =>
                `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, '.')
              }
              parser={(value) => value.replace(/\$\s?|(\.*)/g, '')}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            label="Khuyến mãi"
            name="promotion"
            rules={[{ required: true, message: 'Vui lòng nhập khuyến mãi' }]}
          >
            <InputNumber
              style={{ width: '100%' }}
              placeholder="Nhập khuyến mãi"
              min={0}
              max={100}
              formatter={(value) =>
                `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, '.')
              }
              parser={(value) => value.replace(/\$\s?|(\.*)/g, '')}
            />
          </Form.Item>
        </Col>
      </Row>

      <Row>
        <Col span={12}>
          <Form.Item label="Trạng thái" name="status" valuePropName="checked">
            <Switch />
          </Form.Item>
        </Col>
      </Row>

      {/* <Table
        dataSource={packages}
        columns={typeW == 'PACKAGE' ? columns : columns2}
        pagination={false}
        style={{ marginTop: '16px' }}
        rowKey="key"
      />

      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Button
          type="primary"
          onClick={addPackage}
          style={{ margin: '16px 0' }}
        >
          Thêm gói phí
        </Button>
      </div> */}

      {/* <Row justify="space-between">
        <Button>Quay lại</Button>
        <Button type="primary">Thêm mới</Button>
      </Row> */}
      <ModalConfirm />
    </Form>
  )
}

export default FormPost
